module.exports = __webpack_public_path__ + "static/media/wrap1.8e6c8260.jpg";